/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AnbieterInputs */

const en__field_anbieter = /** @type {(inputs: _Field_AnbieterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const de__field_anbieter = /** @type {(inputs: _Field_AnbieterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {_Field_AnbieterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_anbieter = /** @type {((inputs?: _Field_AnbieterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AnbieterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_anbieter(inputs)
	return de__field_anbieter(inputs)
});